/*global REACT_APP_API_BASE_URL:true*/

/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function getVehicles(_, params) {
  const urlParams = new URLSearchParams(window.location.search);
  const entityId = urlParams.get("entityId");
  let sorting = params.sorter ? params.sorter.split(":") : "";
  let filtering = params.filtering ? params.filters : null;
  let paramsPayload = {
    SkipCount: (params.current - 1) * params.pageSize,
    MaxResultCount: params.pageSize,
  };
  if (sorting) {
    (paramsPayload.column = sorting[0]), (paramsPayload.order = sorting[1]);
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount++;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.FilterText = params.searchValue.toLowerCase().trim();
  }
  let result;
  if (entityId) {
    result = await request(`${REACT_APP_API_BASE_URL}/api/Entities/Vehicles?id=${entityId}`, {
      params: { paramsPayload },
    });
  } else {
    // result = request(`${REACT_APP_API_BASE_URL}/api/Dealer/Vehicles`, {
    result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles`, {
      params: paramsPayload,
    });
  }

  return result;
}

export async function createVehicle(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles`, {
    method: "POST",
    data: payload,
  });

  return result?.data;
}

export async function createAdminVehicle(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin`, {
    method: "POST",
    data: payload,
  });

  return result?.data;
}

export async function editVehicle(data, vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/${vehicleId}`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function editRegulatedVehicle(data, vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/non-sensible/${vehicleId}`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function editAdminVehicle(data, vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function deleteVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/${vehicleId}`, {
    method: "DELETE",
  });

  if (result) {
    const response = result.response;
    return response && response.ok && response.status === 204;
  }

  return result;
}

export async function adminDeleteVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "DELETE",
  });

  if (result) {
    const response = result.response;
    return response && response.ok && response.status === 204;
  }

  return result;
}

export async function uploadBolMedia(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-media`, {
    method: "POST",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result;
}

export async function getAdminVehicles(_, params) {
  let sorting = params.sorter ? params.sorter.split(":") : "";
  let filtering = params.filters ? params.filters : null;
  let paramsPayload = {
    PageNumber: params.current,
    PageSize: params.pageSize,
  };
  if (sorting) {
    paramsPayload.column = sorting[0];
    paramsPayload.order = sorting[1];
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount++;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.search = params.searchValue.toLowerCase().trim();
  }
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Vehicles`, {
    params: paramsPayload,
  });

  return result;
}

export async function getVINData(vin) {
  const params = {
    vin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/decoder`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getVinDataByVehicle(make, model) {
  const params = {
    make,
    model,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/vindecoder-service/decoder/by-vehicle`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getTransporterVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/transporter/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getDealerVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/dealer/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getAdminSingleVehicle(vehicleId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/vehicles/admin/${vehicleId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getBOL(vehicleId) {
  const params = {
    vehicleId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function deleteBOLMedia(data) {
  const params = {
    ids: data,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-media`, {
    method: "DELETE",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getBOLDocuments(vehicleId) {
  const params = {
    vehicleId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/bol-group`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}
